import {BaseViewModel} from "../../../../../infrastructure/models/base-view-model";
import type {ChartEventsDomainModel} from "../chart-events.domain-model";

export class ChartEventsStatusViewModel extends BaseViewModel {
  symbolName: String;
  aliasName: Number;
  sportTypeId: Number;
  isActive: Boolean;
  isFinished: Boolean;
  isNotStarted: Boolean;
  isExtraTime: Boolean;
  isPenalties: Boolean;
  isAbnormal: Boolean;
  gameTimeForStatus: Boolean;
  autonomicTime: Boolean;
  hasEvent: Boolean;


  constructor(model: ChartEventsDomainModel){
    super(model);

    this.symbolName = model.symbolName;
    this.aliasName = model.aliasName;
    this.sportTypeId = model.sportTypeId;
    this.isActive = model.isActive;
    this.isFinished = model.isFinished;
    this.isNotStarted = model.isNotStarted;
    this.isExtraTime = model.isExtraTime;
    this.isPenalties = model.isPenalties;
    this.isAbnormal = model.isAbnormal;
    this.gameimeForStatus = model.gameTimeForStatus;
    this.autonomicTime = model.autonomicTime;
    this.hasEvent = model.hasEvent;
  }
}
